import React from 'react';
import PropTypes from 'prop-types';
import { Label, Text, Input, StyledCheckbox } from './Styled';
import { uniqueId } from 'lodash/util';

const defaultProps = {
  defaultChecked: false,
};

const propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.string.isRequired,
    PropTypes.array.isRequired,
    PropTypes.object.isRequired,
  ]),
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  size: PropTypes.string,
  type: PropTypes.string,
  defaultChecked: PropTypes.bool,
};

const Checkbox = ({
  children,
  id,
  size,
  type,
  defaultChecked,
  checked,
  ...rest
}) => {
  const cId = id ? id : uniqueId('checkbox_');
  return (
    <StyledCheckbox className="styled-checkbox">
      <Label htmlFor={cId} size={size} type={type}>
        {children}
        <Input
          type="checkbox"
          id={cId}
          controlType={type}
          //TODO i change this part as checkbox has no reation for change value from outside
          checked={checked}
          // defaultChecked={checked}
          {...rest}
        />
        <Text size={size} />
      </Label>
    </StyledCheckbox>
  );
};

Checkbox.defaultProps = defaultProps;

Checkbox.propTypes = propTypes;

export default Checkbox;
